((AddTax, $) => {
  'use strict';

  const regexp = /[0-9]/;

  let countryCode;
  let appUrl;
  let taxRate;
  let $priceElements;
  let $orgySleevePrice;
  let $byoItemPrice;
  let $girlItemPrice;

  let GeolizerApiInit = false;

  const pollForGeolizerApi = setInterval(() => {
    if (window.GeolizrAPI && window.GeolizrAPI.hasOwnProperty('api')) {
      GeolizerApiInit = true;
      clearInterval(pollForGeolizerApi);
    }
  }, 1000);

  const cacheDom = () => {
    $priceElements = $('[data-geolizr-price]').not('.cart-sidecar [data-geolizr-price]');
    $orgySleevePrice = $('[data-orgy-sleeve-price]');
    $byoItemPrice = $('[data-price-in-data]');
    $girlItemPrice = $('.js-girl-product-input');
    return true;
  };

  const setOptions = (userOptions) => {
    countryCode = userOptions.countryCode;
    appUrl = userOptions.appUrl;
  };

  const convertPrice = (originalPrice, taxRate) => {
    const price = parseFloat(originalPrice.toFixed(2));
    return price * taxRate + price;
  };

  const setPrice = ($element, attr) => {
    if ($element.length > 0) {
      $element.each(function setElementPrice() {
        const $this = $(this);
        const priceString = $this.attr(attr);
        let priceAdjustedString;
        let originalPrice;
        if (!isNaN(parseFloat(priceString))) {
          originalPrice = parseFloat(priceString);
        } else {
          /**
            * This line slices priceString from the first occurrence of a number
            * to the end of the string. This is to remove money symbols inserted
            * at the beginning of the string by Shopify.
            */
          priceAdjustedString = priceString.slice(priceString.search(regexp), priceString.length);
          originalPrice = parseFloat(priceAdjustedString);
        }
        const newPrice = convertPrice(originalPrice, taxRate);
        $this.attr(attr, newPrice);
      });
      return true;
    }
    return false;
  };

  const run = () => {
    $.ajax({
      method: 'GET',
      url: appUrl,
      dataType: 'json',

      success: (countries) => {
        let country;

        GeolizrAPI.addEventListener('currency.change', function(currency) {
          $('[data-geolizr-price]').css('opacity', '1');
        });

        // Figures out which country to get the tax rate from
        for (let i = 0; i < countries.countries.length; i++) {
          if (countries.countries[i].code.toLowerCase() ===  countryCode.toLowerCase() || countries.countries[i].code === '*') {
            country = countries.countries[i];
            break;
          }
        }
        if (country) {
          setTaxRate(country.tax);
        } else {
          setTaxRate(0);
        }
        setPrice($priceElements, 'data-geolizr-price');
        if (GeolizerApiInit) {
          window.GeolizrAPI.api.switchCurrency(window.GeolizrAPI.api.getCurrency());
        }
        window.Orgy.clickBinds();
        setPrice($orgySleevePrice, 'data-orgy-sleeve-price');
        setPrice($byoItemPrice, 'data-price');
        setPrice($girlItemPrice, 'data-price');
      },

      error: (jqXHR, textStatus, errorString) => {
        const err = new Error(errorString);
        throw err;
      }
    });

    return true;
  };

  const setTaxRate = (rate) => {
    taxRate = rate;
    return taxRate;
  };

  // Calculates a new price based on the passed in price and the global tax rate
  const calculate = (price, rate) => {
    if (rate) {
      taxRate = rate;
    }

    let stringPrice = (price + (price * taxRate)).toString();
    const index = stringPrice.indexOf('.');
    if (index >= 0) {
      stringPrice = stringPrice.slice(0, index + 3);
    }
    return parseFloat(stringPrice);
  };

  const getCountryCode = () => {
    return countryCode;
  };

  const getTaxRate = () => {
    return taxRate;
  };

  const init = (userOptions) => {
    setOptions(userOptions);
    if (countryCode) {
      cacheDom();
      run();
      return true;
    }
    return false;
  };

  // REVEALS PUBLIC METHODS

  AddTax.calculate = calculate;
  AddTax.getCountryCode = getCountryCode;
  AddTax.getTaxRate = getTaxRate;
  AddTax.setPrice = setPrice;
  AddTax.init = init;

})(window.AddTax = window.AddTax || {}, jQuery);
